// Add these imports at the top of your file
import React from 'react';
import { 
  Stack,
  Chip,Paper,Typography,Box
} from '@mui/material';
import InfoItem from './InfoItem'; 

// Add this component definition (can be in the same file or a separate component file)
const ProfileSection = ({ title, icon, items, content, children }) => {
  return (
    <Paper elevation={0} sx={{ 
      p: 3,
      mb: 3,
      borderRadius: 3,
      backgroundColor: '#f9f9f9'
    }}>
      <Typography variant="h6" sx={{ 
        mb: 2,
        pb: 1,
        fontWeight: 600,
        color: 'primary.main',
        borderBottom: '2px solid',
        borderColor: 'primary.light',
        display: 'flex',
        alignItems: 'center'
      }}>
        {React.cloneElement(icon, { sx: { mr: 1 } })}
        {title}
      </Typography>
      
      {content || children || (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
          {items?.map((item, index) => (
            <InfoItem key={index} icon={item.icon} label={item.label} value={item.value} />
          ))}
        </Box>
      )}
    </Paper>
  );
};

export default ProfileSection;